/*global require*/
 
(function ( ) {
	
	/**
	 * @ngdoc module
	 * @name vorm
	 * @module vorm
	 * @description
	 
	 * The `vorm` module is the core and currently only module for vorm.
	 *
	 */
	
	angular.module('vorm', []);
	
})();
